/** Shared icon + label row layout for grid buttons (AnimatedButton, ChatBotButton). */
export const BUTTON_CONTENT_ICON_SLOT_PX = 44;
/** Fixed inner width keeps icons/text aligned across rows when the block is centered in each button. */
/** Fits longest two-line labels (e.g. "Team Analysis" + "Live Post-Draft") without wrapping to 3 lines. */
export const BUTTON_CONTENT_INNER_WIDTH_PX = 144;

/** Section name (line 1): 14px bold. */
export const buttonContentSectionTitleSx = {
  fontSize: "13px",
  fontWeight: 700,
  lineHeight: 1.2,
};

export const buttonContentTwoLinePrimarySx = {
  display: "block",
  whiteSpace: "nowrap",
  ...buttonContentSectionTitleSx,
};

export const buttonContentTwoLineSecondarySx = {
  display: "block",
  whiteSpace: "nowrap",
  fontSize: "13px",
  fontWeight: 400,
  lineHeight: 1.2,
};

const buttonContentRowBase = {
  position: "relative" as const,
  zIndex: 2,
  display: "flex",
  flexDirection: "row" as const,
  alignItems: "center" as const,
  width: "100%",
  boxSizing: "border-box" as const,
  px: 0,
  pl: 1,
};

/** Grid buttons: centered block, column-aligned icon + text. */
export const buttonContentRowGridSx = {
  ...buttonContentRowBase,
  justifyContent: "center",
};

export const buttonContentInnerSx = {
  display: "flex",
  flexDirection: "row" as const,
  alignItems: "center",
  gap: 0.5,
  width: BUTTON_CONTENT_INNER_WIDTH_PX,
  minWidth: BUTTON_CONTENT_INNER_WIDTH_PX,
  maxWidth: BUTTON_CONTENT_INNER_WIDTH_PX,
};

/** Full-width Chatbot on desktop: natural-width icon + label, centered. */
export const buttonContentRowCenteredSx = {
  ...buttonContentRowBase,
  justifyContent: "center",
  gap: 1,
};

export const buttonContentIconSlotSx = {
  width: BUTTON_CONTENT_ICON_SLOT_PX,
  minWidth: BUTTON_CONTENT_ICON_SLOT_PX,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const buttonContentLabelSx = {
  flex: 1,
  minWidth: 0,
  textAlign: "left" as const,
};
